<nav class="navbar navbar-expand-lg navbar-white bg-white">
  <section class="container container-outer">
    <div class="d-flex align-items-center">
      <span class="cursor-pointer" (click)="navigateToHome()">
        <img [src]="networkConfig?.logo || logoPath" alt="" class="me-2" width="auto" [style.height]="HOLISTA_CONSTANT.LAYOUT.HEADER_HEIGHT" />
      </span>
      <p *ngIf="networkName" class="m-0 border-start ps-2">{{ networkName }}</p>
    </div>
    <ul class="nav ms-auto my-lg-0">
      <li class="nav-item">
        <span class="nav-link text-primary cursor-pointer border-end"
          (click)="onLinkClick(HOLISTA_CONSTANT.HOLISTA_ABOUT, true)">About Us
        </span>
      </li>
      <li class="nav-item">
        <a class="nav-link text-primary border-end cursor-pointer" (click)="onLinkClick(HOLISTA_CONSTANT.HOLISTA_GET_STARTED, true)">Let's Get Started</a>
      </li>
      <li class="nav-item d-inline d-sm-none d-md-none d-lg-none ps-1 border-end">
        <span class="nav-link text-primary cursor-pointer" (click)="openContactPopup($event)">Contact</span>
      </li>
    </ul>
    <div class="d-none d-sm-block d-md-block d-lg-block ps-3">
      <small>
        <p class="m-0 lh-sm">
          <a href="tel:+{{networkConfig?.phone}}" class="d-flex align-items-center justify-content-start text-reset">
            <i class="fas fa-mobile-alt text-primary"></i>
            &nbsp; <span class="fst-normal ms-1">855-284-6216</span>
          </a>
        </p>
        <p class="m-0 lh-sm">
          <a href="mailto:{{networkConfig?.email}}" class="d-flex align-items-center justify-content-start text-reset">
            <i class="fas fa-envelope text-primary"></i>
            &nbsp; <span class="fst-normal ms-1">GettingStarted@HolistaHealth.com</span>
          </a>
        </p>
      </small>
    </div>
    <div class="d-none d-sm-block d-md-block d-lg-block ps-3" *ngIf="!isProd">
      <div class="download-dropdown-wrapper">
        <button class="btn btn-outline-dark border-1 d-flex align-items-center gap-2 w-100"
          (click)="toggleDownloadDropdown($event)"
          [disabled]="isDownloading"
          style="border: 1px solid #B3B3B3;">
          <i class="fas fa-download" *ngIf="!isDownloading"></i>
          <span class="spinner-border spinner-border-sm" role="status" *ngIf="isDownloading"></span>
          {{ isDownloading ? 'Downloading...' : 'Download Providers' }}
        </button>
        <ul class="dropdown-menu w-100" [ngClass]="{'show': isDownloadDropdownOpen}">
          <li>
            <span class="dropdown-item cursor-pointer" (click)="onDownload('pdf')">
              <i class="fas fa-file-pdf me-2"></i>Download PDF
            </span>
          </li>
          <li>
            <span class="dropdown-item cursor-pointer" (click)="onDownload('excel')">
              <i class="fas fa-file-excel me-2"></i>Download Excel
            </span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</nav>
